import e from "./Panel.vue_rollup-plugin-vue=script.js";
export default (function (e, n, t, i, s, r, a, l) {
  var o = ("function" == typeof t ? t.options : t) || {};
  return o.__file = "Panel.vue", o.render || (o.render = e.render, o.staticRenderFns = e.staticRenderFns, o._compiled = !0, s && (o.functional = !0)), o._scopeId = i, o;
})({
  render: function render() {
    var e = this,
        n = e.$createElement,
        t = e._self._c || n;
    return t("div", {
      class: [e.suit(), !e.canRefine && e.suit("", "noRefinement")]
    }, [e.getSlot("header") ? t("div", {
      class: e.suit("header")
    }, [e._t("header", null, {
      hasRefinements: e.canRefine
    })], 2) : e._e(), e._v(" "), t("div", {
      class: e.suit("body")
    }, [e._t("default", null, {
      hasRefinements: e.canRefine
    })], 2), e._v(" "), e.getSlot("footer") ? t("div", {
      class: e.suit("footer")
    }, [e._t("footer", null, {
      hasRefinements: e.canRefine
    })], 2) : e._e()]);
  },
  staticRenderFns: []
}, 0, e, void 0, !1);